import Overlay from "./Overlay";
import List from "./List";

class OverlayList extends List {}

OverlayList.type = Overlay;

module.exports = OverlayList;



// WEBPACK FOOTER //
// ./src/js/structs/OverlayList.js